
    <h1  *ngIf='version == 1' mat-dialog-title style="text-align:center;">Start Day</h1>
    <h1  *ngIf='version == 2' mat-dialog-title style="text-align:center;">End Day</h1>
    <div style="display: flex;
    justify-content: center;">
      <p *ngIf='version == 1' style="text-align: center; font-weight:200;">Click 'Confirm' to begin your timecard.</p>
      <p *ngIf='version == 2' style="text-align: center; font-weight:200;">Click 'Confirm' to end your day.</p>
    </div>
    <div style="display: flex;
    justify-content: center;">
      <button mat-button (click)="dref.close(1)"  style="border: 0;
    height: 40px;
    width: 100px;
    margin: 10px;">Confirm</button>
      <button mat-button (click)="dref.close(2)"  style="background: #ffffffaf;
    border: 0;
    height: 40px;
    margin: 10px;
    width: 100px;">Cancel</button>
    </div>
  